<template>
<div class="d-flex min-vh-100">
    <Aside />
    <main class="flex-grow-1 bg-light">
        <div class="p-4">
            <h2 class="mb-4">Ajouter un Article</h2>
            <div class="card shadow-sm p-4">
                <form @submit.prevent="handleSubmit">
                    <!-- Titre -->
                    <div class="mb-3">
                        <label for="title" class="form-label">Titre de l'article</label>
                        <input type="text" id="title" v-model="article.title" class="form-control" placeholder="Entrez le titre de l'article" required />
                    </div>

                    <!-- Contenu avec CKEditor -->
                    <div class="mb-3">
                        <label for="content" class="form-label">Contenu</label>
                        <textarea id="content" v-model="article.content" class="form-control" placeholder="Entrez le contenu de l'article" required style="font-size: 18px; height: 300px;"></textarea>
                    </div>

                    <!-- Image -->
                    <div class="mb-3">
                        <label for="cover" class="form-label">Image de couverture</label>
                        <input type="file" id="cover" @change="handleImageUpload" class="form-control" required />
                    </div>

                    <!-- Catégorie -->
                    <div class="mb-3">
                        <label for="category" class="form-label">Catégorie</label>
                        <select id="category" v-model="article.category" class="form-select" required>
                            <option value="" disabled>Choisissez une catégorie</option>
                            <option v-for="cat in categories" :key="cat" :value="cat">
                                {{ cat }}
                            </option>
                        </select>
                    </div>

                    <!-- Langue -->
                    <div class="mb-3">
                        <label for="language" class="form-label">Langue</label>
                        <select id="language" v-model="article.language" class="form-select" required>
                            <option value="" disabled>Choisissez une langue</option>
                            <option value="fr">Français</option>
                            <option value="en">Anglais</option>
                            <option value="ar">Arabe</option>
                        </select>
                    </div>

                    <!-- Bouton de soumission -->
                    <button type="submit" class="btn btn-primary">Ajouter l'article</button>
                </form>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import axios from '@/api/axios.js';
import Aside from '@/components/Aside.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        Aside
    },

    data() {
        return {
            article: {
                title: '',
                content: '',
                category: '',
                cover: null,
                language: '',
            },
            categories: [
                'Politics',
                'Science',
                'Environment',
                'Sports',
                'Culture',
                'History',
                'Art',
                'Food',
                'Business',
                'Fashion',
                'Music',
                'Gaming',
                'Automotive',
                'Space',
                'Legal',
                'Opinion',
                'Technology Reviews',
                'Startups',
                'Mental Health',
                'Travel Tips',
            ],
        };
    },
    mounted() {
        this.initCKEditor();
    },
    methods: {
        // Initialisation de CKEditor
        initCKEditor() {
            if (window.ClassicEditor) {
                ClassicEditor.create(document.querySelector('#content'), {
                        ckfinder: {
                            uploadUrl: 'https://visennia.com/api/public/api/upload-image',
                        },
                        toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'fontSize', 'fontColor', 'highlight', '|',
                            'link', 'imageUpload', 'insertTable', 'mediaEmbed', '|',
                            'bulletedList', 'numberedList', '|',
                            'blockQuote', 'alignment', 'undo', 'redo', '|',
                            'code', 'codeBlock', '|',
                            'subscript', 'superscript', '|',
                            'indent', 'outdent', '|',
                            'strikethrough', 'underline', '|',
                            'selectAll', 'removeFormat', '|',
                            'horizontalLine', 'specialCharacters', '|',
                            'fullScreen', 'sourceEditing', '|',
                            'pasteFromWord', 'clipboard', '|',
                            'findAndReplace', 'showBlocks'
                        ]

                    })
                    .then(editor => {
                        editor.model.document.on('change:data', () => {
                            this.article.content = editor.getData(); 
                        });

                        const editable = editor.ui.view.editable.element;
                        editable.style.fontSize = '18px';
                        editable.style.height = '400px';
                    })
                    .catch(error => {
                        console.error('Erreur lors de l\'initialisation de CKEditor :', error);
                    });
            } else {
                console.error("CKEditor n'est pas disponible.");
            }
        },

        // Gestion de l'upload de l'image
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.article.cover = file;
            } else {
                console.error("Aucun fichier sélectionné.");
            }
        },

        // Soumission du formulaire
        handleSubmit() {
            // Récupération du user_id depuis sessionStorage
            const userData = JSON.parse(sessionStorage.getItem('user'));
            const userId = userData ? userData.id : null;

            if (!userId) {
                Swal.fire('Erreur', 'Utilisateur non connecté.', 'error');
                return;
            }

            // Validation des champs requis
            if (!this.article.title || !this.article.content || !this.article.category || !this.article.cover || !this.article.language) {
                Swal.fire('Erreur', 'Tous les champs sont obligatoires.', 'error');
                return;
            }

            // Création du FormData
            const formData = new FormData();
            formData.append('title', this.article.title);
            formData.append('content', this.article.content);
            formData.append('category', this.article.category);
            formData.append('cover', this.article.cover);
            formData.append('language', this.article.language);
            formData.append('user_id', userId);

            // Envoi de la requête avec Axios
            axios
                .post('/add-article', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                })
                .then((response) => {
                    Swal.fire('Succès', 'Article ajouté avec succès !', 'success');
                    // Réinitialisation des données du formulaire
                    this.article = {
                        title: '',
                        content: '',
                        category: '',
                        cover: null,
                    };
                    document.querySelector('#cover').value = ''; // Réinitialisation de l'input file
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        console.error('Erreurs de validation :', error.response.data.errors);
                        Swal.fire('Erreur', 'Erreur : ' + JSON.stringify(error.response.data.errors), 'error');
                    } else {
                        console.error('Erreur lors de l\'ajout de l\'article :', error);
                        Swal.fire('Erreur', 'Une erreur est survenue.', 'error');
                    }
                });
        },
    },
};
</script>

<style scoped>

</style>
